export const SET_SELECTED_OPEN_SPACE = 'OPEN_SPACE/SET_SELECTED_OPEN_SPACE';
export const UNSET_SELECTED_OPEN_SPACE = 'OPEN_SPACE/UNSET_SELECTED_OPEN_SPACE';
export const SET_OPEN_SPACES_LIST = 'OPEN_SPACE/SET_OPEN_SPACES_LIST';
export const UNSET_OPEN_SPACES_LIST = 'OPEN_SPACE/UNSET_OPEN_SPACES_LIST';
export const SET_FETCHING_OPEN_SPACES_STATUS = "OPEN_SPACE/SET_FETCHING_OPEN_SPACES_STATUS";
export const UNSET_FETCHING_OPEN_SPACES_STATUS = "OPEN_SPACE/UNSET_FETCHING_OPEN_SPACES_STATUS";